// const { filter } = require("lodash");


if ($(".carCards_container_filtering").length) {
    // Evaluates if there is any needed filtering

    window.justFired = false;
    let containerInDom = $(".carCards_container_filtering");

    let containerCards = containerInDom.isotope({
        getSortData: {
            featured: "[data-featured] parseInt",
            is_featured: "[data-is-featured] parseInt",
            price_low: "[data-price-low] parseFloat",
            price_high: "[data-price-high] parseFloat",
        },
        itemSelector: ".car-item",
        layoutMode: "vertical",
        transitionDuration: 600,
    });

    let actualFilter = "*";
    let mostSuitcases = checkMostSuitcases("[radioButtonFilter]");
    let previousGroup;
    let previousSuitcases;

    containerCards.isotope({ filter: function() {
        var $this = $(this);
        
        // regenerateOrders()
        window.justFired = true;
        return $this.is(actualFilter);
      } });
      var hasFeatured = $(".filterOrderBySelect option[value='featured']").length > 0;
      sortByOriginal(hasFeatured ? "featured" : "asc", false);

    //Filtros checkbox
    let allCategories = $('.categoriesFilter');
    let allFilterCheckbox = $('.allFilter');
    let allFilterBrands = $('.brandsFilter');

    $("[checkboxFilter]").on("change", function () {
        let uniqueName = $(this).attr("name");
        let checkBoxes = $(`[name|="${uniqueName}"]`);

        if($(this).attr("data-filter").includes('filter-all')){

            actualFilter = "*";

            if ($(".categoriesFilter:checked").length == 0) {

                allFilterCheckbox.prop("checked", true);

            }else{
                allFilterCheckbox.prop("checked", true);
                allCategories.each(function(){
                    if($(this).attr("data-filter").includes('filter-category')){
                        $(this).prop("checked", false);
                    }
                })

            }

            allFilterBrands.each(function(){
                if(!$(this).is(":checked")){
                    let filterData = $(this).data("filter");
                    if(!actualFilter.includes(`:not(.${filterData})`)){
                        actualFilter = `${actualFilter}:not(.${filterData})`;
                    }
                }
            })
        }

        if($(this).attr("data-filter").includes('filter-category')){

            allCategories.each(function(){
                if(!$(this).is(":checked")){
                    let filterData = $(this).data("filter");
                    if(!actualFilter.includes(`:not(.${filterData})`)){
                        actualFilter = `${actualFilter}:not(.${filterData})`;
                    }
                }
            })

            allFilterCheckbox.prop("checked", false);
        }

        if ($(this).is(":checked")) {
            checkBoxes.each(function () {
                $(this).prop("checked", true);
            });
            refreshFilter($(this).attr("data-filter"), true);
        } else {
            refreshFilter($(this).attr("data-filter"), false);
            checkBoxes.each(function () {
                $(this).prop("checked", false);
            });
        }
    });

    //Filtros Group Select
    $(".filterCarGroupSelect").on("change", function () {
        let value = $(this).val();
        if (value != " ") {
            if (previousGroup != undefined) {
                actualFilter = actualFilter.replace(
                    `.filter-groups-${previousGroup}`,
                    ""
                );
            }
            actualFilter = `${actualFilter}.filter-groups-${value}`;
            previousGroup = value;
        } else {
            actualFilter = actualFilter.replace(
                `.filter-groups-${previousGroup}`,
                ""
            );
        }

        containerCards.isotope();
    });
    $(".filterSuitcaseSelect").on("change", function () {
        let value = $(this).val();
        if (value != " ") {
            if (previousSuitcases != undefined) {
                actualFilter = actualFilter.replace(
                    `.filter-suitecases-${previousSuitcases}`,
                    ""
                );
            }
            actualFilter = `${actualFilter}.filter-suitecases-${value}`;
            previousSuitcases = value;
        } else {
            actualFilter = actualFilter.replace(
                `.filter-suitecases-${previousSuitcases}`,
                ""
            );
        }

        containerCards.isotope();
    });

    //Ordernar Por
    $(".filterOrderBySelect").on("change", function () {
        let value = $(this).val();
        featured = $("#checkbox_featured").is(":checked")
        sortByOriginal(value, featured)
    });

    function sortByOriginal(value, featured) {
        switch (value) {
            case "desc":
                containerCards.isotope({
                    sortBy: featured ? ["featured", "price_high"] : "price_high",
                    sortAscending: {
                        featured: featured,
                        price_high: false,
                    },
                });
                break;
            case "featured":
                containerCards.isotope({
                    sortBy: ["is_featured", "price_low"],
                    sortAscending: {
                        is_featured: true,
                        price_low: true,
                    },
                });
                break;
            case " ":
            case "null":
            case "asc":
                containerCards.isotope({
                    sortBy: featured ? ["featured", "price_low"] : "price_low",
                    sortAscending: {
                        featured: featured,
                        price_low: true,
                    },
                });
                break;
            }
            window.justFired = true
    }

    $("#checkbox_featured").on("change", function (){
        let isChecked = $(this).is(":checked")
        let orderByValue = $(".filterOrderBySelect").val();
        sortByOriginal(orderByValue, isChecked);
    })


    //Filtros Radio Buttons
    $("[radioButtonFilter]").on("change", function () {
        let filterAttributeInRadio = $(this).attr("data-filter").split("-");
        let numberInFilterAttributeInRadio = filterAttributeInRadio[2];
        let prefixInFilterAttributeInRadio = `${filterAttributeInRadio[0]}-${filterAttributeInRadio[1]}`;

        let uniqueName = $(this).attr("id");
        let checkRadios = $(`.${uniqueName}`);

        if ($(this).is(":checked")) {
            if (window.innerWidth >= 1280) {
                $(checkRadios[0]).prop("checked", true);
            } else {
                $(checkRadios[1]).prop("checked", true);
            }
        }

        // Removes all the filter suitecases cases
        for (let index = 0; index < mostSuitcases; index++) {
            actualFilter = actualFilter.replace(
                `:not(.${prefixInFilterAttributeInRadio}-${index})`,
                ""
            );
        }
        for (let index = 0; index < numberInFilterAttributeInRadio; index++) {
            actualFilter = `${actualFilter}:not(.${prefixInFilterAttributeInRadio}-${index})`;
        }

        containerCards.isotope();
    });


    function refreshFilter(filterData, isOn) {

        if (isOn) {
            actualFilter = actualFilter.replaceAll(`:not(.${filterData})`, "");
        } else {
            actualFilter = `${actualFilter}:not(.${filterData})`;
        }
        //Filters
        containerCards.isotope();
    }


}



function checkMostSuitcases(selector) {
    let response = 0;

    $(selector).each((e, element) => {
        let number = $(element).attr("data-filter").split("-")[2];
        if (response == 0 || number > response) {
            response = number;
        }
    });
    return response;
}

function concatValues( obj ) {
    var value = '';
    for ( var prop in obj ) {
      value += obj[ prop ];
    }
    return value;
  }

function delay(callback, ms) {
    let timer = 0
    return function(...args) {
        clearTimeout(timer)
        timer = setTimeout(callback.bind(this, ...args), ms || 0)
    }
}


function fireLazy(){
    $('.car_image_step1').lazy({
        bind: "event",
        scrollDirection: 'vertical',
        effect: 'fadeIn',
        visibleOnly: true,
        threshold: 1000,
        onError: function(element) {
            // console.log("error", element);
            element.attr('src', '/dist/images/step1/awaiting-image.webp');
        },
    });
}

window.fireLazy = fireLazy;

